import React from "react";
import "./Pricing.css";
import { Link } from "react-router-dom";

const Pricing = () => {
  return (
    <div className="pricing-section">
      <h2 className="pricing-title">Promotional Discounted Rates</h2>
      <div className="pricing-cards">
        <div className="card free">
          <h3>Free Listing</h3>
          <p className="price">US$0</p>
          <ul>
            <li>Free listing for 6 months</li>
            <li>Minor updates available</li>
            <li>Community exposure</li>
            <li><strong>PROMO Code:</strong> FREE4GOH03</li>
          </ul>
          <Link to="/partner-signup" className="btn">Get Started</Link>
        </div>

        <div className="card basic">
          <h3>Basic Listing</h3>
          <p className="price">US$50</p>
          <ul>
            <li>Business listing</li>
            <li>Ad placement</li>
            <li>Coupon codes available</li>
            <li><strong>PROMO Code:</strong> GOOURHUB2503</li>
            <li>Valid for 6 months</li>
          </ul>
          <Link to="/partner-signup" className="btn">Start Now</Link>
        </div>

        <div className="card premium">
  <div className="ribbon">Premium</div>
  <div className="crown">👑</div>
  <h3>Premium Listing</h3>
  <p className="price">US$150</p>
  <ul>
    <li>Listing valid for 1 year</li>
    <li>Ad placement</li>
    <li>Social media marketing</li>
    <li>Premium tags & exposure</li>
    <li>Special coupon codes</li>
  </ul>
  <Link to="/partner-signup" className="btn">Go Premium</Link>
</div>

      </div>
    </div>
  );
};

export default Pricing;
